The identifier of the library question or suggestion that the component is based on.

If the library question was suggested via the `applicationLibraryQuestionSuggestions` query,
you should supply the `ApplicationLibraryQuestionSuggestion.id` rather than the `ApplicationLibraryQuestion.id`.

If the library question was retrieved outside of a suggestion context,
you may supply its underlying `ApplicationLibraryQuestion.id`.
